import React, { Fragment, useState } from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import DialogContent from "@mui/material/DialogContent";
import { lensProp, set } from "ramda";
import Grid from "@mui/material/Grid";
import { notBlank } from "../../util/ext";
import { useBuyingGroupMemberAdd } from "../organizationServices";
import {
  validateBuyingGroupMember,
  validateBuyingGroupMemberField,
} from "../organizationValidation";
import OrganizationAutoComplete from "../../user-admin/OrganizationAutoComplete";
import { useErrorBox } from "./use-errorBox";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import { Box } from "@mui/material";

const BuyingGroupMemberDialog = ({
  organizationId,
  open,
  onCancel,
  onSave,
}) => {
  const [fields, setFields] = useState({
    memberId: null,
  });

  const {
    addValidationError,
    removeValidationError,
    setValidationErrors,
    setGeneralError,
    hasValidationError,
    firstValidationError,
    ErrorBox: DialogErrors,
  } = useErrorBox();

  const onFieldChange = field => value => {
    const update = set(lensProp(field), value, fields);
    setFields(update);
  };

  const handleBlur = (field, value) => {
    const validationErrors = validateBuyingGroupMemberField(field, value);
    if (notBlank(validationErrors)) {
      addValidationError(validationErrors);
    } else {
      removeValidationError(field);
    }
  };

  const [waiting, setWaiting] = useState(false);
  const memberAdd = useBuyingGroupMemberAdd();
  const handleApply = async () => {
    const validationErrors = validateBuyingGroupMember(fields);
    if (notBlank(validationErrors)) {
      setValidationErrors(validationErrors);
    } else {
      setWaiting(true);
      try {
        await memberAdd.mutateAsync({
          resourceIds: {
            orgId: organizationId,
            memberId: fields.memberId,
          },
        });
        onSave(fields.memberId);
      } catch (err) {
        setGeneralError(err);
      } finally {
        setWaiting(false);
      }
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">New Member Organization</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Select an Organization to add as a Buying Group Member
        </DialogContentText>
        <DialogErrors />
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <OrganizationAutoComplete
              autoFocus
              value={fields.memberId}
              filterFunction={org => org.active}
              onChange={onFieldChange("memberId")}
              onBlur={() => handleBlur("memberId", fields.memberId)}
              error={hasValidationError("memberId")}
              helperText={firstValidationError("memberId")}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        {waiting ? (
          <Box display="flex" justifyContent="flex-end" padding={2}>
            <PanelLoadingIndicator size={25} />
          </Box>
        ) : (
          <Fragment>
            <Button onClick={onCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleApply} color="primary">
              Apply
            </Button>
          </Fragment>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default BuyingGroupMemberDialog;
